/**
 * useUnsavedChangesGuard (#233)
 *
 * Warns the user before they lose entered configuration by leaving the page via
 * a full unload -- reload, tab close, or navigating to an external/typed URL.
 * While `when` is true a `beforeunload` handler is installed; it is removed when
 * `when` becomes false or the component unmounts.
 *
 * In-app (SPA) navigation is NOT covered here: the app uses a non-data
 * <BrowserRouter>, so react-router's useBlocker is unavailable. Callers guard
 * their own in-app exit affordances (e.g. a breadcrumb link) with a confirm.
 */
import { useEffect } from 'react';

export const useUnsavedChangesGuard = (when: boolean): void => {
  useEffect(() => {
    if (!when) return;

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Legacy browsers require returnValue to be set to trigger the prompt.
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [when]);
};
